import { getFormatedDiscountCenterCfg } from '@/api/homev3';
import { Information, Banner, Block, DiscountNotice, ActBanner, NoticeItem, NoticeItemType } from '@/types/index';
import { getHomeDiscountRecord } from '@/api/index';
import { initMaxAdData } from '@/business/homev3/max-ad';
import { isValidDate } from '@/util/dateHelper';
import { getActList, getBannerActList } from '@/business/homev3/activity';

/**
 * 初始化页面数据
 */
export async function initData() {
  const pageData = await getFormatedDiscountCenterCfg();
  // 模块布局
  const discountCenterMoudleCfg = getModuleCfg(pageData.discountCenterMoudleCfg);
  // 资讯模块
  const discountCenterInfoCfg = getInfoList(pageData.discountCenterInfoCfg);
  // banner
  // const discountCenterBannerCfg = getBannerList(pageData.discountCenterBannerCfg);
  // 活动列表
  // const dsicountCenterActivityCfg = await getActList(pageData.dsicountCenterActivityCfg);
  // 新版banner活动列表
  const discountCenterBannerActivityCfg = await getBannerActList(pageData.dsicountCenterBannerActivityCfg);

  const { discountCenterMaxAdCfg, abtTestDivertCfg, discountCenterActivityBannerCfg } = pageData;
  // 筛选符合ABT的巨幕banner配置
  const discountCenterActivityCfgAfterABT = await initMaxAdData(discountCenterMaxAdCfg, abtTestDivertCfg);

  // // 获取活动banner
  // const activityBannerCfg = getActBanner(discountCenterActivityBannerCfg);

  return {
    discountCenterMoudleCfg,
    discountCenterInfoCfg,
    // discountCenterBannerCfg,
    // dsicountCenterActivityCfg,
    discountCenterBannerActivityCfg,
    discountCenterMaxAdCfg: discountCenterActivityCfgAfterABT,
    // activityBannerCfg,
  };
}

/** 优惠记录的接口返回 */
type GetHomeDiscountRecordResp = Array<{
  count: number,
  prize_name: string,
  create_time: string,
}>

/**
 * 处理优惠信息记录
 */
export async function getDiscountListData() {
  const res = await getHomeDiscountRecord({
    page_size: '20',
    page_num: '0',
    qual_type_list: '1',
  }) as GetHomeDiscountRecordResp;

  const listData: NoticeItem[] = res.map(item => {
    return {
      content: `${item.prize_name} × ${item.count}`,
      rightContent: item.create_time.slice(0, 10),
      click: function () {
        // @ts-ignore
        this.$router.push({ name: 'discountrecord' });
      },
      type: NoticeItemType.EStamp,
    }
  })
  return listData;
}

/**
 * 处理模块配置
 */
export function getModuleCfg(discountCenterMoudleCfg: Block[]) {
  // 排序
  const blockCfgAferSort = discountCenterMoudleCfg.sort((a, b) => {
    return b.sort - a.sort;
  });
  return blockCfgAferSort;
}

/**
 * 处理资讯模块上下架、排序等逻辑
 */
export function getInfoList(discountCenterInfoCfg: Information[]) {
  // 过滤时间不对的
  const discountCenterInfoCfgFilterTime = discountCenterInfoCfg.filter(info => {
    return isValidDate(info.startTime, info.endTime);
  })
  // 排序
  const discountCenterInfoCfgAferSort = discountCenterInfoCfgFilterTime.sort((a, b) => {
    return b.order - a.order;
  })
  // 最多展示7条
  // const discountCenterInfoCfgLimit = discountCenterInfoCfgAferSort.slice(0,7);
  return discountCenterInfoCfgAferSort;
}

/**
 * 处理banner模块
 */
export function getBannerList(discountCenterBannerCfg: Banner[]) {
  // 过滤时间不对的
  const discountCenterBannerCfgFilterTime = discountCenterBannerCfg.filter(banner => {
    return isValidDate(banner.startTime, banner.endTime);
  })
  // 排序
  const discountCenterBannerCfgAferSort = discountCenterBannerCfgFilterTime.sort((a, b) => {
    return b.sort - a.sort;
  })
  return discountCenterBannerCfgAferSort;
}

export function getActBanner(actBanner: ActBanner[]) {
  // 过滤时间不对的
  const abs = actBanner.filter(banner => {
    return isValidDate(banner.startTime, banner.endTime);
  })
  return abs;
}
